/** Periodicidades da aplicação */
export interface Periodicidade {
    id: number;
    nome: string;
}

export const periodicidadePeriodo: Periodicidade = {id: 1, nome: 'Período'};
export const periodicidadeTrimestre: Periodicidade = {id: 2, nome: 'Trimestre'};
export const periodicidadeAno: Periodicidade = {id: 3, nome: 'Ano'};

export const periodicidades: Periodicidade[] = [
    periodicidadePeriodo,
    periodicidadeTrimestre,
    periodicidadeAno
];

/** Verifica se a Periodicidade é por Período */
export function isPeriodicidadePeriodo(id: number): boolean {
    return id === periodicidadePeriodo.id;
}

/** Verifica se a Periodicidade é por Trimestre */
export function isPeriodicidadeTrimestre(id: number): boolean {
    return id === periodicidadeTrimestre.id;
}

/** Verifica se a Periodicidade é por Ano */
export function isPeriodicidadeAno(id: number): boolean {
    return id === periodicidadeAno.id;
}
